<div class="headline">
  <div>
    <h1 class="subtitle1">
      {{text?.headline ? text.headline : languages.headline}}
    </h1>
    <span *ngIf="this.rule === 'optional'" class="caption">{{this.rule}}</span>
  </div>
  <p class="body2">{{text?.excerpt ? text.excerpt : languages.description}}
</div>
